module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "bc-offpay-mask",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.onClose($event)
      }
    }
  }, [_c('div', {
    staticClass: "bc-offpay"
  }, [_c('button', {
    staticClass: "bc-offpay__close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h2', {
    staticClass: "bc-offpay__title"
  }, [_vm._v(_vm._s(_vm.$T('观众中心线下收款')))]), _vm._v(" "), (_vm.payPrice) ? _c('p', {
    staticClass: "bc-offpay__amount"
  }, [_vm._v("\n      " + _vm._s(_vm.$T('观众中心应付')) + "："), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.payPrice)))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "bc-offpay__hint"
  }, [_vm._v(_vm._s(_vm.$T('观众中心线下收款说明')))]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "bc-offpay__loading"
  }, [_vm._v(_vm._s(_vm.$T('观众中心加载中')))]) : [(_vm.account.qrcode_url) ? _c('div', {
    staticClass: "bc-offpay__qr-wrap"
  }, [_c('img', {
    staticClass: "bc-offpay__qr",
    attrs: {
      "src": _vm.account.qrcode_url,
      "alt": _vm.$T('观众中心收款二维码')
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bc-offpay__qr-tip"
  }, [_vm._v(_vm._s(_vm.$T('观众中心扫码付款')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bc-offpay__account"
  }, [_c('h3', [_vm._v(_vm._s(_vm.account.title || 'Company Account'))]), _vm._v(" "), _c('dl', [_c('div', [_c('dt', [_vm._v("Beneficiary Name")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.account.beneficiary_name))])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Beneficiary Account No.")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.account.beneficiary_account))])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Bank Name")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.account.bank_name))])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("SWIFT Code")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.account.swift_code))])]), _vm._v(" "), _c('div', [_c('dt', [_vm._v("Bank Address")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.account.bank_address))])])])]), _vm._v(" "), _c('button', {
    staticClass: "bc-offpay__btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onPaid
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$T('观众中心我已支付')) + "\n      ")])]], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3227749c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/SpectatorOfflinePayDialog.vue
// module id = 1404
// module chunks = 0